import CSVColumnsStrategy from '../CSVColumnsStrategy'
import {ReportGroupingLevel} from '../../../constants'

export default function TTDetailCSVPreviewColumnsStrategy(){}

TTDetailCSVPreviewColumnsStrategy.prototype = new CSVColumnsStrategy();
TTDetailCSVPreviewColumnsStrategy.prototype.constructor = TTDetailCSVPreviewColumnsStrategy;

TTDetailCSVPreviewColumnsStrategy.prototype.init = function(notEmptyGroupingLevels, joinCommentsByTask, needSwitchToMe){
    this.notEmptyGroupingLevels = notEmptyGroupingLevels;
    this.joinCommentsByTask = joinCommentsByTask;
    // calculate detail cells
    this.detailCells = TTDetailPreviewUtils.calculateTTCDetailCells(notEmptyGroupingLevels, joinCommentsByTask);
    this.needSwitchToMe = needSwitchToMe

    return this;
};

/**
 * Add cells  for main header row (grouping columns + details columns + total column + comment column)
 * @param headerRow
 */
TTDetailCSVPreviewColumnsStrategy.prototype.addFirstHeaderRowCells = function( headerRow){
    for(let i = 0; i < this.notEmptyGroupingLevels.length; i++) {
        this.addCell(headerRow, ReportPreviewUtils.getLevelPreviewName(this.notEmptyGroupingLevels[i]))
    }
    for(let i = 0; i < this.detailCells.length; i++ ) {
        const detailCell = this.detailCells[i]
        const levelPreviewName = detailCell === ReportGroupingLevel.USER && this.needSwitchToMe ?
                                 this.message("report.common.me") :
                                 ReportPreviewUtils.getLevelPreviewName(detailCell)
        this.addCell(headerRow, levelPreviewName)
    }
    this.addCell(headerRow, this.message("reports.comments_report.report.spent"));
    this._addCommentsCell(headerRow, true);
};

/**
 * Add rows for hierarchy grouping section
 * Cust  ___  ____ position = 0
 *  ___  Prj  ____ position = 1
 *  ___  ___  Task position = 2
 * @param row current row
 * @param position position of row from 0 to 2 (depends grouping level)
 */
TTDetailCSVPreviewColumnsStrategy.prototype.addDataLevelRowCells = function( row, position ){
    for(let i = 0; i  < position; i++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    const groupingLevel = this.notEmptyGroupingLevels[position]
    let levelPreviewName
    if (this.needSwitchToMe && groupingLevel === ReportGroupingLevel.USER) {
        levelPreviewName = this.message("report.common.me")
    } else {
        levelPreviewName = ReportPreviewUtils.getLevelPreviewName(groupingLevel)
    }
    this.addCell(row, levelPreviewName);
    for (let i = position + 1; i < this.notEmptyGroupingLevels.length; i++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    for(let i = 0; i < this.getNumberOfDetailsCells(); i++) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    this.addTimeValueCell(row); // total value
    ReportPreviewUtils.addEmptyCell(row);
};

TTDetailCSVPreviewColumnsStrategy.prototype.addDataRowCells = function( row ) {
    for(let i = 0; i < this.notEmptyGroupingLevels.length; i++ ) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    for(let i = 0; i < this.detailCells.length; i++ ) {
        const detailCell = this.detailCells[i]
        const levelPreviewName = detailCell === ReportGroupingLevel.USER && this.needSwitchToMe ?
                                 this.message("report.common.me") :
                                 ReportPreviewUtils.getLevelPreviewName(detailCell)
        this.addCell(row, levelPreviewName)
    }
    this.addTimeValueCell(row);
    this._addCommentsCell(row, false);
};

TTDetailCSVPreviewColumnsStrategy.prototype.addTotalRowCells = function( row ) {
    const nBeforeEmptyCells = this.notEmptyGroupingLevels.length + this.getNumberOfDetailsCells() - 1
    this._addTotalCell(row);
    for(let i = 0; i < nBeforeEmptyCells; i++ ) {
        ReportPreviewUtils.addEmptyCell(row);
    }
    this.addTimeValueCell(row);
    ReportPreviewUtils.addEmptyCell(row);
};

TTDetailCSVPreviewColumnsStrategy.prototype._addCommentsCell = function(row, isHeader) {
   if(isHeader || !this.joinCommentsByTask){
       this.addCell(row, ReportPreviewUtils.getLevelPreviewName(ReportGroupingLevel.TT_COMMENTS));
   } else {
       this.addCell(row, this.message("reports.comments_report.form.preview.joined_comments"));
   }
};

TTDetailCSVPreviewColumnsStrategy.prototype._addTotalCell = function( row ) {
    this.addCell(row, this.message("report.total"));
};

TTDetailCSVPreviewColumnsStrategy.prototype.getNumberOfDetailsCells = function() {
    return this.detailCells.length;
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/ttdetail/TTDetailCSVPreviewColumnsStrategy.js